export function getPayslipCutoffs() {
    return {
        "success": true,
        "message": "Record fetched successfully",
        "record": {
            "success": true,
            "data": [
                {
                    "id": 8604,
                    "date_generated": "2025-10-16",
                    "generated_by": null,
                    "generated_by_name": "Chris Ann Beloya",
                    "approved_by": null,
                    "payroll_from": "2025-10-01",
                    "payroll_to": "2025-10-15",
                    "store": "Sparkle Star International - Inhouse",
                    "created_at": "2025-10-16 00:00:00",
                    "updated_at": "2025-10-17 19:18:30",
                    "company": null,
                    "status": "Save",
                    "display": 1,
                    "created_by": null,
                    "cutoff": 1,
                    "breaklist": "46cd74c0-aa79-11f0-8021-23749161231a",
                    "requested_otp": null,
                    "otp": null
                },
            ]
        }
    }
}